<template>
  <div>
    <settings-top-nav :selectedScreenName="selectedScreenInfo.name"
      :componentname="selectedComponent"
      @changeToSelectedScreensTableComponent='changeToSelectedCustomMetadataComponent'
      :showAddCustomKeyButton="selectedComponent != 'add-screen'">
    </settings-top-nav>
    <component :is="selectedComponent" v-bind="currentProperties"
    :selectedScreenName="selectedScreenInfo.name"
      @changeToSelectedScreensTableComponent='changeToSelectedCustomMetadataComponent'
    @changeToSelectedCustomKeyComponent='changeToSelectedCustomMetadataComponent'></component>
  </div>
</template>

<script>

// import AddScreen from "./AddScreen.vue"
import ShowScreens from "./showScreens.vue"
import SreenInfo from "./screenInfo.vue"
import settingsTopNav from "./HeaderBar.vue"

export default {
  name: "Screen",
  data() {
    return {
      selectedComponent: ShowScreens,
      selectedScreenInfo: {}
    };
  },
  provide() {
    return {
      changeSelectedComponent: this.changeSelectedComponent,
    };
  },
  components: {
    // "add-screen": AddScreen,
    "screen-info": SreenInfo,
    "show-screens": ShowScreens,
    "settings-top-nav": settingsTopNav,
  },
  methods: {
    changeToSelectedCustomMetadataComponent(compName, screenDetails) {
      this.selectedComponent = compName;
      this.selectedScreenInfo = screenDetails
    },
    showBinsTopNav() {
      let comps = [
        // "add-screen",
        "screen-info"
      ];
      if (comps.indexOf(this.selectedComponent) > -1) {
        return true;
      }
    }
  },
  computed:{
      currentProperties() {
      if (this.selectedComponent === "screen-info") {
        return { selectedScreenId : this.selectedScreenInfo._id};
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>